var map = {
	"./burger.svg": "2e69",
	"./chevron.svg": "ac6d",
	"./close.svg": "bf37",
	"./discord.svg": "abfa",
	"./dots.svg": "4a85",
	"./etherscan.svg": "4b5d",
	"./mute.svg": "8913",
	"./opensea.svg": "1232",
	"./pause.svg": "ec7e",
	"./play.svg": "5830",
	"./rainbow.svg": "0bee",
	"./reveal_closed.svg": "88a8",
	"./reveal_opened.svg": "e7e1",
	"./screens/about/about.svg": "a923",
	"./screens/artist/artist.svg": "c0e8",
	"./screens/information/faq_after.svg": "f008",
	"./twitter.svg": "a3df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";